import PageHeader from "../components/PageHeader";
import ConfigTabs from "../components/ConfigTabs";
import useSettings from "../hooks/useSettings";
import { Save, Mail, Phone, MessageSquare, MapPin, Clock, Send } from "lucide-react";

export default function ConfigContact() {
  const { form, set, save, loading } = useSettings();
  if (!form) return <div className="bg-white border border-gray-200 rounded-sm p-10 text-center text-sm text-gray-500">Loading...</div>;

  return (
    <div data-testid="config-contact-page">
      <PageHeader title="Configuration" subtitle="Contact · support channels and business information" />
      <ConfigTabs />
      <form onSubmit={(e) => { e.preventDefault(); save(); }} className="bg-white border border-gray-200 rounded-sm p-6 max-w-4xl space-y-5" data-testid="config-contact-form">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Support Email" icon={Mail}>
            <input type="email" value={form.support_email || ""} onChange={(e) => set("support_email", e.target.value)} className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm" data-testid="cfg-contact-email" />
          </Field>
          <Field label="Support Phone" icon={Phone}>
            <input value={form.support_phone || ""} onChange={(e) => set("support_phone", e.target.value)} className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm tabular" data-testid="cfg-contact-phone" />
          </Field>
          <Field label="WhatsApp Number" icon={MessageSquare}>
            <input value={form.whatsapp_number || ""} onChange={(e) => set("whatsapp_number", e.target.value)} className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm tabular" placeholder="+8801XXXXXXXXX" data-testid="cfg-contact-whatsapp" />
          </Field>
          <Field label="Telegram Username" icon={Send}>
            <input value={form.telegram_username || ""} onChange={(e) => set("telegram_username", e.target.value)} className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm" placeholder="@supportbot" data-testid="cfg-contact-telegram" />
          </Field>
          <Field label="Business Hours" icon={Clock}>
            <input value={form.business_hours || ""} onChange={(e) => set("business_hours", e.target.value)} className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm" placeholder="24/7 or Mon-Fri 9-5" />
          </Field>
          <Field label="Office Address" icon={MapPin}>
            <input value={form.office_address || ""} onChange={(e) => set("office_address", e.target.value)} className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm" />
          </Field>
        </div>

        {/* ---- Contact page hero stats (the 3 cards at the top of /contact) ---- */}
        <div className="pt-5 border-t border-gray-100">
          <div className="text-[12px] font-bold uppercase tracking-wider text-gray-700 mb-3">
            Contact Page · Hero Stats (3 cards shown to players)
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="space-y-2">
              <div className="text-[11px] uppercase tracking-wider text-gray-500 font-semibold">Card 1 — Support hours</div>
              <input value={form.contact_stat_hours_value || ""} onChange={(e) => set("contact_stat_hours_value", e.target.value)} placeholder="24/7" className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm font-bold" data-testid="cfg-contact-stat-hours-value" />
              <input value={form.contact_stat_hours_label || ""} onChange={(e) => set("contact_stat_hours_label", e.target.value)} placeholder="Support Hours" className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm" data-testid="cfg-contact-stat-hours-label" />
            </div>
            <div className="space-y-2">
              <div className="text-[11px] uppercase tracking-wider text-gray-500 font-semibold">Card 2 — Live chat avg.</div>
              <input value={form.contact_stat_chat_value || ""} onChange={(e) => set("contact_stat_chat_value", e.target.value)} placeholder="< 1 min" className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm font-bold" data-testid="cfg-contact-stat-chat-value" />
              <input value={form.contact_stat_chat_label || ""} onChange={(e) => set("contact_stat_chat_label", e.target.value)} placeholder="Live Chat Avg." className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm" data-testid="cfg-contact-stat-chat-label" />
            </div>
            <div className="space-y-2">
              <div className="text-[11px] uppercase tracking-wider text-gray-500 font-semibold">Card 3 — Email reply</div>
              <input value={form.contact_stat_email_value || ""} onChange={(e) => set("contact_stat_email_value", e.target.value)} placeholder="< 4 h" className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm font-bold" data-testid="cfg-contact-stat-email-value" />
              <input value={form.contact_stat_email_label || ""} onChange={(e) => set("contact_stat_email_label", e.target.value)} placeholder="Email Reply" className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm" data-testid="cfg-contact-stat-email-label" />
            </div>
          </div>
        </div>

        <div className="flex justify-end pt-4 border-t border-gray-100">
          <button type="submit" disabled={loading} className="h-10 px-5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-sm text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-50" data-testid="cfg-contact-save">
            <Save size={14} /> {loading ? "Saving..." : "Save Contact Info"}
          </button>
        </div>
      </form>
    </div>
  );
}

function Field({ label, icon: Icon, children }) {
  return (
    <div>
      <label className="block text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1.5 flex items-center gap-1.5">
        {Icon && <Icon size={12} />} {label}
      </label>
      {children}
    </div>
  );
}
